var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"loading mt-5"},[_vm._v("cloning building configuration ...")]),_c('div',{staticClass:"loading-gif mt-5"},[_c('circle-loader',{attrs:{"size":40}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }